import React, { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from "react-i18next";
//UI
import HeaderSearch from '../../../../components/headers/catalogs/HeaderSearch';
import HomeLayout from '../../../../layouts/HomeLayout';
import MainLoader from '../../../../components/Loaders/MainLoader';
import Error from '../../../../components/errors/Error';

//SLICE
import { getProcesStatusReportThunk, initialStateReports } from '../../../../store/slices/reportes/reports.slice';
import ProgresoItem from '../../../../components/matriculations/ProgresoItem';
import EstadoMatricula from '../../../../components/matriculations/EstadoMatricula';

const ProcesStatusReport = () => {
    const { t } = useTranslation();
    const dispatch = useDispatch();
    const { items, error } = useSelector(state => state.reports);
    const [searchTerm, setSearchTerm] = useState('');
    const isLoading = useSelector(state => state.isLoadingSlice);
    const [filter, setFilter] = useState('');

    useEffect(() => {
        dispatch(getProcesStatusReportThunk());
        return () => {
            dispatch(initialStateReports());
        };
    }, []);

    const filteredProducts = useMemo(() => {
        if (!Array.isArray(items)) return [];

        if (searchTerm) {
            return items.filter(item =>
                item.student?.apellido?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        }

        return items;
    }, [searchTerm, items]);

    // const handleGenerateExcel = () => {
    //     //generateExcelContratos()
    // }

    // const handleGenerateReport = (item) => {
    //     downloadDocument(item.documento?.name, item.id);
    // };


    const filterFuntion = (e) => {
        const value = e.target.value === 'true'; // Convierte el string a boolean
        setFilter(value);
        dispatch(getProcesStatusReportThunk(value));
    };

    return (
        <HomeLayout>
            {isLoading || items?.length === 0 ? (
                <MainLoader />
            ) : (
                <div className='mx-5 my-5 w-full'>
                    {error ? <Error state={error} /> : " "}
                    <div className='flex w-full items-center p-2 border mb-2 shadow-sm'>
                        <div className='w-full'>
                            <HeaderSearch
                                title={t("Estudiantes")}
                                searchTerm={searchTerm}
                                funtion={e => setSearchTerm(e.target.value)}
                            />
                        </div>
                        <div className='flex items-center justify-end w-full space-x-4 text-sm'>
                            <p className=' uppercase font-semibold'>Estado de proceso</p>
                            <div className='flex items-center space-x-4 border p-2 shadow-sm'>
                                <div className='flex items-center justify-center gap-3'>
                                    <label htmlFor="">Pendientes</label>
                                    <input
                                        name='filter'
                                        value={false}
                                        checked={filter === false}
                                        onChange={filterFuntion}
                                        className="cursor-pointer w-full outline-none input-bordered focus:outline-none focus:ring-1  text-sm border font-normal p-1 rounded-lg"
                                        type="radio"
                                    />
                                </div>
                                <div className='flex items-center justify-center gap-3'>
                                    <label htmlFor="">Finalizados</label>
                                    <input
                                        name='filter'
                                        value={true}
                                        checked={filter === true}
                                        onChange={filterFuntion}
                                        className=" cursor-pointer w-full outline-none input-bordered focus:outline-none focus:ring-1  text-sm border font-normal p-1 rounded-lg"
                                        type="radio"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="border rounded overflow-hidden h-[89%] flex flex-col">
                        <table className="w-full text-[15px] table-sm table-zebra text-start">
                            <thead className='border-t-2 border-t-p-green'>
                                <tr className='text-left h-[50px] bg-p-orange/80 text-white'>
                                    <th className='w-[300px]'>{t("Información Personas")}</th>
                                    <th>{t("Contratos")}</th>
                                    <th>{t("Documentos")}</th>
                                    <th>{t("Formularios")}</th>
                                    <th>{t("Estado")}</th>
                                </tr>
                            </thead>
                        </table>
                        {/* Contenedor scrollable para tbody */}
                        <div className="overflow-y-auto flex-1">
                            <table className="w-full text-[13px] table-sm table-zebra text-start">
                                <tbody>
                                    {filteredProducts?.map((user, index) =>
                                        <tr className='h-[50px]' key={index}>
                                            <td className='w-[300px]'>
                                                <div className='flex flex-col gap-2'>
                                                    <div>
                                                        <p className='flex flex-col items-start text-p-sky text-[14px] font-semibold'>
                                                            <span className='mb-[-5px] text-[12px] text-gray-400 flex items-center gap-2'> Estudiante</span>
                                                            {user.student?.apellido} {user.student?.nombre}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {user.student?.ci_estudiante}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {user.student?.course?.name + ', ' + user.student?.level?.name}
                                                        </p>
                                                    </div>
                                                    <div>
                                                        <p className='flex flex-col items-start text-p-sky text-[14px] font-semibold '>
                                                            <span className='mb-[-5px] text-[12px] text-gray-400 flex items-center gap-2'> Representante</span>
                                                            {user.parent?.apellido} {user.parent?.nombre}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {'CI: ' + user.parent?.ci_padre} / {'Telf: ' + user.parent?.celular}
                                                        </p>
                                                        <p className='flex items-center gap-2 text-gray-500'>
                                                            {user.parent?.email}
                                                        </p>
                                                    </div>
                                                </div>
                                            </td>
                                            <td>
                                                <ProgresoItem
                                                    label={'Contratos'}
                                                    completados={user.progreso?.contratos?.completados}
                                                    total={user.progreso?.contratos?.total}
                                                />
                                            </td>
                                            <td>
                                                <ProgresoItem
                                                    label={'Documentos'}
                                                    completados={user.progreso?.documentos?.completados}
                                                    total={user.progreso?.documentos?.total}
                                                />
                                            </td>
                                            <td>
                                                <ProgresoItem
                                                    label={'Formularios'}
                                                    completados={user.progreso?.formularios?.completados}
                                                    total={user.progreso?.formularios?.total}
                                                />
                                            </td>
                                            <td>
                                                <EstadoMatricula estado={user.matriculationEnd} />
                                            </td>
                                        </tr>
                                    )}
                                </tbody>
                            </table>
                        </div>

                        {/* Tfoot fijo abajo */}
                        <table className="w-full text-[13px] table-sm table-zebra text-start">
                            <tfoot>
                                <tr className='bg-gray-100 text-gray-700'>
                                    <th colSpan={3} className='flex items-center justify-end gap-2 text-right p-2'>
                                        Total de registros: <p className='text-p-sky text-[18px]'>{filteredProducts.length}</p>
                                    </th>
                                </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            )}
        </HomeLayout>
    );
};

export default ProcesStatusReport;